import template from './item.html';
import controller from './item.controller';

let itemComponent = {
    bindings: {
        model: '=',
        editing: '<',
        displayFinals: '<',
        onDelete: '&',
        onSave: '&',
        associatingSpending: '<',
        onUpdateAssociatedAmount: '&'
    },
    template,
    controller
};

export default itemComponent;
